import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import '../styles/ThreadHistory.css';

function ThreadHistory({ messages }) {
  return (
    <div className="thread-history">
      <h3>Conversation History</h3>
      <div className="messages-list">
        {messages.map((msg, idx) => (
          <div
            key={msg.id}
            className={`message ${msg.direction}`}
          >
            <div className="message-header">
              <span className="direction-label">
                {msg.direction === 'in' ? '📨 Inbound' : '📤 Outbound'}
              </span>
              <span className="message-time">
                {formatDistanceToNow(new Date(msg.ts), { addSuffix: true })}
              </span>
            </div>
            <div className="message-body">
              {msg.body}
            </div>
            {msg.sentiment && (
              <div className="message-meta">
                <span className={`sentiment sentiment-${msg.sentiment}`}>
                  {msg.sentiment}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ThreadHistory;
